<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<div class="login-container">
  <div class="login-content-container">
    <app-hearhub-logo
      [inverted]="false"
      class="login-brand-logo"
    ></app-hearhub-logo>
    <div class="welcome-text">Welcome to HearHub</div>
    <div class="login-content-txt">
      The portal uses external Microsoft Office 365 to authenticate valid users.
      If you are a registered user of the system, click the link below to
      proceed to login. You will be redirected to the Microsoft Login Page
      (login.microsoft.com), please login with the provided username and
      password.
    </div>

    <div class="login-button">
      <app-action-button
        (onClick)="handleClick()"
        color="primary"
        kind="filled"
        size="extra-large"
        type="button"
        >Login
      </app-action-button>
    </div>
    <div class="login-support-text-container service-text">
      Forgotten your password? Please contact your
      <a
        class="email-text"
        href="mailto:support@hearhub.org?subject=Support Needed"
      >
        support&#64;hearhub.org </a
      >.
    </div>
  </div>
  <div class="login-image-container">
    <img
      alt="Right Image"
      class="login-image"
      src="/assets/images/TSC-Login-Image.jpg"
    />
  </div>
</div>
